import { HOMEPAGE, STATS_UPDATED_AT } from "@/lib/siteStats";

// Homepage counters. Values come from the single public/stats.json snapshot —
// see lib/siteStats.ts for how that file is produced.
//
// projects_delivered = client_products + custom_products + user_websites.
// happy_customers / global_partners come from defaultdb, not the website's own
// users table.
export const PROJECTS_DELIVERED = HOMEPAGE.projects_delivered;
export const HAPPY_CUSTOMERS = HOMEPAGE.happy_customers;
export const GLOBAL_PARTNERS = HOMEPAGE.global_partners;

export { STATS_UPDATED_AT };
